import CampaignBase from '../../CampaignBase';

const enableProduct = [18, 25]; // link, ace

// 特殊分销优惠文案
class AffiliateCoupon extends CampaignBase {
  constructor(props) {
    super(props);
    this.enabled = true;
  }

  // 产品页是否展示
  enableProductPage = (productInfo = {}, from = 'page') => {
    const { pid } = productInfo;
    switch (from) {
      case 'discountIntro':
        return this.enabled && enableProduct.includes(pid);
      default:
        return false;
    }
  };

  // 折扣信息展示到折扣模块
  getProductDiscountIntro = ({ pid }) => {
    if (!enableProduct.includes(pid)) return null;

    const aceAffDiscount10 = this.pageCommonConfig?.aceAffDiscount10 ?? [];
    const aceAffDiscount11 = this.pageCommonConfig?.aceAffDiscount11 ?? [];
    const linkAffDiscountSp = this.pageCommonConfig?.linkAffDiscountSp ?? [];

    let locale = '';

    switch (pid) {
      case 18:
        if (linkAffDiscountSp.includes(this.insrc)) locale = this.LANG['activity.2024AffCoupon.special_discount_link'];
        break;
      case 25:
        if (aceAffDiscount10.includes(this.insrc)) locale = this.LANG['activity.2024AffCoupon.discount10'];
        else if (aceAffDiscount11.includes(this.insrc)) locale = this.LANG['activity.2024AffCoupon.discount11'];
        break;
      default:
        break;
    }

    // return { text: locale, isTop: true };
    // 取消置顶
    return { text: locale };
  };
}

export { AffiliateCoupon };
